import { Pipe, PipeTransform } from '@angular/core';
import { ProductModel } from '../models/product.model';

@Pipe({ name: 'objectToArray', pure:false })
export class ObjectToArrayPipe implements PipeTransform {
  transform(obj:any) {
    if(!!obj){
      return Object.entries(obj)
        .map(entry => <any>{ key: entry[0],...entry[1] as {}})
    }
    else { return []}
  }
}